/****************************************************
 * Module Name:  symProxy.js
 * Project:      Pansuriya Impex Sales & Manufacturing
 * Owner:        info@pansuriyaimpex.com
 *
 * Copyright (c) Pansuriya Impex
 * All rights reserved.
 ****************************************************/
import restAPICall from "../../api/restAPICall";
import Constants from "../../constants";

export default class SymProxy {
  static GetAllSym = (callback) => {
    restAPICall(
      Constants.MANAGER_URL + "/sym",
      "get",
      Constants.userToken,
      undefined,
      undefined,
      undefined,
      0
    )
      .then((response) => callback(response))
      .catch((error) => {
        callback(undefined);
      });
  };

  static GetAllSymMini = (callback) => {
    restAPICall(
      Constants.MANAGER_URL + "/sym/mini",
      "get",
      Constants.userToken,
      undefined,
      undefined,
      undefined,
      0
    )
      .then((response) => callback(response))
      .catch((error) => {
        callback(undefined);
      });
  };

  static GetSingleSym = (symId, callback) => {
    let params = {
      id: symId,
    };

    restAPICall(
      Constants.MANAGER_URL + "/sym",
      "get",
      Constants.userToken,
      params,
      undefined,
      undefined,
      0
    )
      .then((response) => callback(response))
      .catch((error) => {
        callback(undefined);
      });
  };

  static CheckSymAvailable = (sym, callback) => {
    let params = {
      sym: sym,
    };

    restAPICall(
      Constants.MANAGER_URL + "/sym/available",
      "get",
      Constants.userToken,
      params,
      undefined,
      undefined,
      0
    )
      .then((response) => callback(response))
      .catch((error) => {
        callback(undefined);
      });
  };

  static AddSym = (sym, callback) => {
    restAPICall(
      Constants.MANAGER_URL + "/sym",
      "post",
      Constants.userToken,
      undefined,
      JSON.stringify(sym),
      "application/json",
      0
    )
      .then((response) => callback(response))
      .catch((error) => {
        callback(undefined);
      });
  };

  static UpdateSym = (sym, callback) => {
    restAPICall(
      Constants.MANAGER_URL + "/sym",
      "put",
      Constants.userToken,
      undefined,
      JSON.stringify(sym),
      "application/json",
      0
    )
      .then((response) => callback(response))
      .catch((error) => {
        callback(undefined);
      });
  };
}
